(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name services.factory:RefereeList
   *
   * @description
   *
   */
  angular
    .module('neo.services')
    .factory('partitstutor', partitstutor);

  function partitstutor($resource, EnvironmentConfig) {
    return $resource(EnvironmentConfig.API + '/partitstutor/:dia/:mes/:any/:dia2/:mes2/:any2', 
    {dia: '@_dia',mes: '@_mes',any: '@_any',dia2: '@_dia2',mes2: '@_mes2',any2: '@_any2'}, {
      update: {
        method: 'PUT'
      },
      query: {
        method: 'GET',
        isArray: true
      }
    });
  }
}());